<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="star icon"></i>
      {{ $t("rating") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/teacher_rating.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <!-- <h4 class="ui dividing header">{{ $t("basic information") }}</h4> -->
          <div class="fields">
            <div class="disabled eight wide field">
              <label for="">{{ $t("evaluated user") }}</label>
              <input type="text" :value="target_user_name" />
            </div>
            <!-- <div class="six wide field">
              <label for="">{{ $t("rating") }}</label>
              <input type="text" name="rating" v-model="rating" />
            </div> -->
            <div class="disabled eight wide field">
              <label for="">{{ $t("date") }}</label>
              <input type="text" name="date" :value="selected_date" />
            </div>
          </div>
          <div class="ui divider supdivider"></div>
          <div class="ui grid" v-for="(item, iidx) in items" :key="iidx">
            <div class="nine wide column cuacuac">
              <i
                class="red asterisk icon"
                v-if="
                  item.mandatory && show_mandatory_mark && is_not_answered(item)
                "
              ></i>
              {{ item.prompt }}
            </div>
            <div class="seven wide column cuacuac">
              <div
                class="ui mini icon labeled button"
                :style="'background-color: ' + answer.color + ' !important'"
                v-bind:class="{
                  basic: !is_answer_selected(answer, item),
                  green: is_answer_selected(answer, item),
                }"
                v-for="(answer, aidx) in item.answers"
                :key="aidx"
                @click="set_answer(item, answer)"
              >
                <i :class="answer.icon + ' icon'"></i> {{ answer.prompt }}
              </div>
            </div>
            <!-- <div class="ui divider"></div> -->
          </div>
          <div class="ui divider infdivider"></div>
          <!-- <pre>{{ responses }}</pre>
          <div class="ui divider infdivider"></div> -->
          <div class="field">
            <label>{{ $t("comment") }}</label>
            <textarea name="comment" rows="2" v-model="comment"></textarea>
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated red icon right labeled button"
        @click="remove"
        v-show="uuid"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, clone } from "@/utils";
// import moment from "moment";
// import GenericModal from "@/components/GenericModal";
// import General from "./General";

export default {
  name: "RatingModal",
  components: {
    // "generic-modal": GenericModal,
    // General,
  },
  computed: {
    items() {
      let vm = this;
      let items = vm.evaluation_template.items || [];

      /** items are ordered */
      items = items.sort((a, b) => {
        {
          if (Number(a.order || 0) > Number(b.order || 0)) return 1;
          else if (Number(a.order || 0) < Number(b.order || 0)) return -1;
          else return 0;
        }
      });
      return items;
    },
  },
  props: {},
  data() {
    return {
      target_user_id: "",
      target_user_name: "",
      target_organization_id: "",
      target_template_id: "",
      uuid: "",
      // rating: "",
      selected_date: "",
      comment: "",
      evaluation_template: {},
      responses: [],
      show_mandatory_mark: false,
    };
  },
  methods: {
    show_modal(options) {
      let vm = this;
      if (options) {
        vm.target_user_id = options.target_user_id;
        vm.target_user_name = options.target_user_name;
        vm.uuid = options.uuid;
        // vm.rating = options.startRating;
        vm.selected_date = options.info.dateStr;
        vm.comment = options.comment;
        if (options.response) vm.responses = clone(options.response);

        if (options.target_organization_id)
          vm.target_organization_id = options.target_organization_id;

        // console.log("options", options);
        if (options.target_template_id) {
          vm.target_template_id = options.target_template_id;
          local_api(
            vm,
            "post",
            "/staff_rating/teacher/do-get-evaluation-template",
            { i: options.target_template_id },
          )
            .then((evaluation_template) => {
              if (evaluation_template) {
                vm.evaluation_template = evaluation_template;
              } else {
                error_toast(vm.$t("evaluation mode not configured yet"));
              }
            })
            .catch((err) => {
              error_toast(err);
            });
        }
      }
      // console.log(options);
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.target_user_id = "";
            vm.ratings = [];
            vm.responses = [];
          },
          onShow() {},
        })
        .modal("show");
    },
    save() {
      let vm = this;
      let isValid = window.jQuery(vm.$refs.form).form("validate form");
      let validTemplateRules = vm.validate_rules();
      if (isValid && validTemplateRules) {
        local_api(vm, "post", "/staff_rating/teacher/do-save", {
          // r: vm.rating,
          u: vm.target_user_id,
          o: vm.target_organization_id,
          d: vm.selected_date, // moment(info.date).format("YYYY-MM-DD"),
          i: vm.uuid,
          p: vm.responses,
          s: { comment: vm.comment },
          t: vm.evaluation_template.template_id,
        })
          .then(() => {
            vm.$emit("saved");
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove rating?"),
        function () {
          local_api(vm, "post", "/staff_rating/teacher/do-remove", {
            u: vm.uuid,
          })
            .then(() => {
              vm.$emit("deleted");
              window.jQuery(vm.$refs.modal).modal("hide");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    set_answer(item, answer) {
      let vm = this;
      let rspnsIndx = vm.responses.findIndex((r) => {
        return r.aspect.uuid == item.uuid && r.answer.uuid == answer.uuid;
      });

      if (rspnsIndx > -1) {
        vm.responses.splice(rspnsIndx, 1);
      } else if (rspnsIndx == -1) {
        // console.log("hre");
        /** If is only one answer allowed */
        if (item.max_answers == 1) {
          /** Remove previous answer */
          let trgtIdx = vm.responses.findIndex((rs) => {
            return rs.aspect.uuid == item.uuid;
          });
          console.log("trgtIdx", trgtIdx);
          if (trgtIdx >= 0) vm.responses.splice(trgtIdx, 1);
        }

        let questionAnswers = vm.responses.filter((r) => {
          return r.aspect.uuid == item.uuid;
        });

        if (item.max_answers > questionAnswers.length) {
          vm.responses.push({
            aspect: {
              uuid: item.uuid,
              prompt: item.prompt,
              category_id: item.category_id,
            },
            answer: {
              uuid: answer.uuid,
              prompt: answer.prompt,
              weight: answer.weight,
            },
          });
        }
      }
    },
    is_answer_selected(answer, question) {
      let vm = this;
      let exists = vm.responses.find((rr) => {
        return rr.aspect.uuid == question.uuid && rr.answer.uuid == answer.uuid;
      });
      if (exists) return true;
      else return false;
    },
    validate_rules() {
      let vm = this;
      let unevaluated_items = vm.evaluation_template.items.filter((i) => {
        return !vm.responses.find((r) => {
          return r.aspect.uuid == i.uuid;
        });
      });

      let isValid = true;
      let arr_error = [];

      if (
        unevaluated_items.length >
        Number(vm.evaluation_template.max_unevaluated)
      ) {
        let err_max_unevaluated = `${vm.$t("you have")} ${
          unevaluated_items.length
        } ${vm.$t("unevaluated aspects, the maximum is")} ${
          vm.evaluation_template.max_unevaluated
        }`;
        arr_error.push(err_max_unevaluated);
        isValid = false;
      }

      let mandatory_unevaluated = unevaluated_items.filter((ui) => {
        return ui.mandatory;
      });
      if (mandatory_unevaluated.length > 0) {
        let err_mandatory = vm.$t(
          "mandatory aspects are marked with a red asterisk",
        );
        arr_error.push(err_mandatory);
        isValid = false;
      }

      if (!isValid) {
        window.jQuery(vm.$refs.form).form("add errors", arr_error);
        vm.show_mandatory_mark = true;
      }

      return isValid;
    },
    is_not_answered(item) {
      let vm = this;
      let exists = vm.responses.find((rr) => {
        return rr.aspect.uuid == item.uuid;
      });
      if (exists) return false;
      else return true;
    },
  },
  created() {},
  mounted() {
    // let vm = this;
  },
  updated: function () {},
  watch: {},
};
</script>

<style>
.cuacuac {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.supdivider {
  padding-bottom: 10px !important;
}

.infdivider {
  margin-top: 25px !important;
}
</style>
